<template>
<div class="filemapcomponent" id="filemapcomponent">
    <div class="columns is-mobile" v-if="isInEditMode==false">
        <div class="column is-8 is-offset-2 is-hidden-mobile is-hidden-tablet-only">
            <div class="button wwButton is-fullwidth " @click="isInEditMode=true">Bearbeiten</div>
        </div>
    </div>
    <div v-if="isInEditMode==true" class="columns is-mobile">
        <div class="column is-4 is-offset-2">
            <input v-model="newAreaName" type="text" class="input"></input>
        </div>
        <div class="column is-4">

            <div class="button is-success savebutton" @click="saveAreas()" :disabled="areasToSave.length<=0">Speichern</div>
            <div class="button is-danger" @click="cancelEdit()">Abbrechen</div>
        </div>
    </div>
    <div class="p5map">
        <vue-p5 v-on="{setup,draw,render,mousemoved,mousepressed,mousereleased,preload}"></vue-p5>
    </div>
    <div class="downloadmap">
    <div class="button" @click="downloadMap()">Download</div></div>
    <div>
    </div>
</div>
</template>

<script>
import VueP5 from 'vue-p5';

export default {
    name: 'DrawMap',
    props: ["isInEditModex", "existingrectangles", "selectedArea"],
    components: {
        VueP5
    },
    mounted: function () {
        this.rectangles = this.existingrectangles
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            rectangles: [],
            canvasWidth: "100%",
            canvasHeight: 500,
            newRectangle: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 0
            },
            isDrawingRectangle: false,
            newRectangleIsValid: true,
            p5obj: null,
            isInEditMode: false,
            areasToSave: [],
            backgroundImage: null,
            newAreaName: "newAreaname"
        }
    },
    methods: {
        downloadMap(){
            console.log("downloading")
              this.p5obj.save( 'myCanvas');

        },
        preload(sketch) {
            var img = require('@/assets/bauplan.jpg')
            console.log(".." + img)
            console.log("preloading")
            var loadedImage = sketch.loadImage(".." + img)
            loadedImage.resize(500, 500);

            this.backgroundImage = loadedImage

        },
        setup(sketch) {
            //var canvasDiv = document.getElementById('filemapcomponent');
            // var width = canvasDiv.offsetWidth;
            this.backgroundImage.resize(500, 500);
            sketch.createCanvas(this.backgroundImage.width, this.backgroundImage.height);
            this.p5obj = sketch;

            sketch.background(this.backgroundImage);

        },
        draw(sk) {
            this.drawBasic(sk);

            this.drawAllRectangles(sk)
            if (this.isInEditMode != true) {
                sk.noLoop();
                return;
            }
            this.drawNewRectangle(sk);
        },
        drawBasic(sketch) {
            //sketch.background('grey');

            sketch.background(this.backgroundImage);

        },
        convertImageCoordinates(x, y) {
            /*Wir speichern */
        },

        drawAllRectangles(sketch) {
            //data = x1, y1, x2, y2, zb 0 0 100 100
            for (var indexpos = 0; indexpos < this.rectangles.length; indexpos++) {
                var rectangle = this.rectangles[indexpos];
                var color = "rgba(10%,60%,10%,0.2)"
                if (rectangle.Color != undefined && rectangle.Color != null && rectangle.Color != "") {
                    color = rectangle.Color
                }
                if (rectangle.id != undefined && rectangle.id != null && rectangle.id != -1 && this.selectedArea == rectangle.id) {
                    color = "rgba(10%,60%,100%,0.6)"
                }
                this.drawRectangle(sketch, rectangle.Left, rectangle.Top, rectangle.Right, rectangle.Bottom, color)

            }

            for (var indexpos = 0; indexpos < this.areasToSave.length; indexpos++) {
                var rectangle = this.areasToSave[indexpos];
                var color = "rgba(10%,60%,10%,0.2)"
                if (rectangle.Color != undefined && rectangle.Color != null && rectangle.Color != "") {
                    color = rectangle.Color
                }
                if (rectangle.id != undefined && rectangle.id != null && rectangle.id != -1 && this.selectedArea == rectangle.id) {
                    color = "rgba(10%,60%,100%,0.6)"
                }
                this.drawRectangle(sketch, rectangle.Left, rectangle.Top, rectangle.Right, rectangle.Bottom, color)

            }

        },
        drawRectangle(sketch, x1, y1, x2, y2, color) {

            //sketch.fill(color(0, 0, 255));
            if (color != null && color != undefined && color != "") {
                sketch.fill(color);

            }

            sketch.rect(x1, y1, (x2 - x1), (y2 - y1));

        },
        drawNewRectangle(sketch) {

            if (!this.isInsideCanvas(sketch.mouseX, sketch.mouseY)) {
                this.isDrawingRectangle = false;
            }
            if (!this.isDrawingRectangle) {
                return;
            }
            this.newRectangleIsValid = true;
            this.newRectangle.x2 = sketch.mouseX;
            this.newRectangle.y2 = sketch.mouseY;

            if (this.isOverlapping(this.newRectangle.x1, this.newRectangle.x2, this.newRectangle.y1, this.newRectangle.y2)) {
                this.newRectangleIsValid = false;

            }
            if (this.newRectangleIsValid) {
                this.drawRectangle(sketch, this.newRectangle.x1, this.newRectangle.y1, this.newRectangle.x2, this.newRectangle.y2, "rgba(10%,50%,10%,0.1)")

            } else {
                this.drawRectangle(sketch, this.newRectangle.x1, this.newRectangle.y1, this.newRectangle.x2, this.newRectangle.y2, "rgba(50%,10%,10%,0.1)")

            }

        },
        isOverlapping(x1, x2, y1, y2) {
            var RectA = {
                Left: 0,
                Right: 0,
                Top: 0,
                Bottom: 0
            }
            var RectB = {
                Left: 0,
                Right: 0,
                Top: 0,
                Bottom: 0
            }

            if (x1 < x2) {
                RectA.Left = x1
                RectA.Right = x2

            } else {
                RectA.Left = x2
                RectA.Right = x1
            }

            if (y1 < y2) {
                RectA.Top = y2
                RectA.Bottom = y1
            } else {
                RectA.Top = y1
                RectA.Bottom = y2
            }

            for (var indexpos = 0; indexpos < this.rectangles.length; indexpos++) {
                var rect = this.rectangles[indexpos];
                var rectX1 = rect.Left
                var rectY1 = rect.Top
                var rectX2 = rect.Right
                var rectY2 = rect.Bottom

                if (rectX1 < rectX2) {
                    RectB.Left = rectX1
                    RectB.Right = rectX2
                } else {
                    RectB.Left = rectX2
                    RectB.Right = rectX1
                }

                if (rectY1 < rectY2) {

                    RectB.Top = rectY2
                    RectB.Bottom = rectY1

                } else {
                    RectB.Top = rectY1
                    RectB.Bottom = rectY2
                }

                if (RectA.Left < RectB.Right && RectA.Right > RectB.Left &&
                    RectA.Top > RectB.Bottom && RectA.Bottom < RectB.Top) {
                    return true;
                }

            }
            return false;

        },
        getRectangle(x, y) {
            if (!this.isInsideCanvas(x, y)) {
                return null;
            }
            for (var indexpos = 0; indexpos < this.rectangles.length; indexpos++) {
                var rect = this.rectangles[indexpos];
                if (rect.Left <= x && rect.Right >= x) {
                    if (rect.Top >= y && rect.Bottom <= y) {
                        return rect
                    }
                }
            }
            return null;
        },
        render(h) {
            h.text('Hello p5333!', 20, 20);

            return h(VueP5, {
                on: this
            });
        },
        keypressed(sk) {
            const key = String.fromCharCode(sk.keyCode);
            if (sk.keyCode === sk.LEFT_ARROW) {}
            sk.text(key, 20, 50);
        },
        isInsideCanvas(x, y) {
            if (x < 0 || y < 0 || x > this.canvasWidth || y > this.canvasHeight) {
                return false;
            } else {
                return true;
            }
        },

        mousepressed(sketch) {

            if (this.isInEditMode != true) {
                var rect = this.getRectangle(sketch.mouseX, sketch.mouseY)
                if (rect != null) {
                    this.$emit("select", rect.id)
                }
                return;
            }

            if (this.isDrawingRectangle == true) {
                this.isDrawingRectangle = false;
                return;
            }
            if (this.isInsideCanvas(sketch.mouseX, sketch.mouseY)) {

                this.isDrawingRectangle = true;
                this.newRectangle = {
                    x1: sketch.mouseX,
                    y1: sketch.mouseY,
                    x2: sketch.mouseX,
                    y2: sketch.mouseX
                }
            }
        },
        mousereleased(sketch) {
            if (this.isDrawingRectangle && this.isInsideCanvas(sketch.mouseX, sketch.mouseY)) {
                this.isDrawingRectangle = false;
                this.addRectangle();
            }
            //    alert("mouse clicked")
        },
        mousemoved(sketch) {

        },
        addRectangle() {
            this.areasToSave = []
            if (this.newRectangle.x1 > this.newRectangle.x2) {
                var tempX1 = this.newRectangle.x1;
                this.newRectangle.x1 = this.newRectangle.x2;
                this.newRectangle.x2 = tempX1;
            }
            if (this.newRectangle.y1 > this.newRectangle.y2) {
                var tempY1 = this.newRectangle.y1;
                this.newRectangle.y1 = this.newRectangle.y2;
                this.newRectangle.y2 = tempY1;
            }

            if (this.isOverlapping(this.newRectangle.x1, this.newRectangle.x2, this.newRectangle.y1, this.newRectangle.y2)) {
                this.newRectangleIsValid = false;

            }
            this.$forceUpdate()

            if (this.newRectangleIsValid) {

                    var newRectangle = {
                        Left: this.newRectangle.x1,
                        Right: this.newRectangle.x2,
                        Top: this.newRectangle.y2,
                        Bottom: this.newRectangle.y1,
                        name: this.newAreaName
                    }
                    this.areasToSave.push(newRectangle)

            }

        },
        saveAreas() {
            if (this.areasToSave.length <= 0) {
                return;
            }
            this.areasToSave[0].name = this.newAreaName
            this.newAreaName = "Areaname"
            this.$emit("save", this.areasToSave)
                        this.areasToSave = []

            this.isInEditMode = false
        },
        cancelEdit() {
            this.isInEditMode = false
            this.areasToSave = []
            this.newAreaName = "Areaname"
            this.$emit("canceledit")

        }

    },
    computed: {},
    watch: {

        existingrectangles: function (newVal, oldVal) { // watch it
            this.drawBasic(this.p5obj)

            this.rectangles = this.existingrectangles
            this.drawAllRectangles(this.p5obj)

        },
        selectedArea: function (newVal, oldVal) { // watch it
            this.drawBasic(this.p5obj)
            this.drawAllRectangles(this.p5obj)
        },
        isInEditMode: function (newVal, oldVal) { // watch it
            this.drawBasic(this.p5obj)
            this.drawAllRectangles(this.p5obj)
            if (this.p5obj == null) {
                return;
            }
            if (newVal == true) {
                this.p5obj.loop();
            } else {
                this.p5obj.noLoop()
            }
        }
    }
}
</script>

<style scoped>
.savebutton{margin-right:10px;}
</style>
